import { render, staticRenderFns } from "./siteInfo.vue?vue&type=template&id=0676e6ba&scoped=true&"
import script from "./siteInfo.vue?vue&type=script&lang=js&"
export * from "./siteInfo.vue?vue&type=script&lang=js&"
import style0 from "./siteInfo.vue?vue&type=style&index=0&id=0676e6ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0676e6ba",
  null
  
)

export default component.exports